/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Workflow_Palette_HintInputs */

const cs_workflow_palette_hint = /** @type {(inputs: Workflow_Palette_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Přetáhněte z levé palety, nebo klikněte pro umístění. Pozice zůstávají.`)
};

const en_workflow_palette_hint = /** @type {(inputs: Workflow_Palette_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Drag from the left palette, or click to place. Positions stay put.`)
};

/**
* | output |
* | --- |
* | "Drag from the left palette, or click to place. Positions stay put." |
*
* @param {Workflow_Palette_HintInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const workflow_palette_hint = /** @type {((inputs?: Workflow_Palette_HintInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workflow_Palette_HintInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_workflow_palette_hint(inputs)
	return cs_workflow_palette_hint(inputs)
});